import Fields from "../../Forms/Fields";

/**
 * Sweet little script for loading the component files automagically
 */

// Define contexts to require
const contexts = [require.context("./", true, /\.vue$/)];

// Define components
const forms = [];
contexts.forEach((context) => {
	context.keys().forEach((key) => forms.push(context(key).default));
});

// Install the above defined forms
const Forms = {
	install(Vue) {
		forms.forEach((form) => {
			Vue.component(form.name, form);
		});
		// SInce these are used in the forms we'll load them here.
		Vue.use(Fields);
	}
};

// Finally export as default
export default Forms;
